<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-operator">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">新增</a-button>
        </div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading">
          <template slot="isDefaultSlot" slot-scope="text, record">
            <a-tag v-if="record.isDefault === '1'" color="green">默认</a-tag>
            <span v-else>-</span>
          </template>
          <template slot="enabledSlot" slot-scope="text, record">
            <a-tag :color="record.enabled === '1' ? 'blue' : 'red'">{{ record.enabled === '1' ? '启用' : '停用' }}</a-tag>
          </template>
          <span slot="action" slot-scope="text, record">
            <a v-if="btnEnableList.indexOf(1)>-1 && record.isDefault !== '1'" @click="handleEdit(record)">编辑</a>
            <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.isDefault !== '1'" type="vertical" />
            <a v-if="btnEnableList.indexOf(4)>-1 && record.isDefault !== '1'" @click="handleToggle(record)">{{ record.enabled === '1' ? '停用' : '启用' }}</a>
            <a-divider v-if="btnEnableList.indexOf(4)>-1 && record.isDefault !== '1'" type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1 && record.isDefault !== '1'" title="确定删除该等级吗？" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <level-modal ref="modalForm" @ok="modalFormOk"></level-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import LevelModal from './modules/LevelModal'
import { levelList, levelDelete, levelToggle } from '@/api/plugin/member'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'LevelList',
  mixins: [JeecgListMixin],
  components: {
    LevelModal
  },
  data() {
    return {
      // 按钮权限匹配键，须与菜单URL一致（JeecgListMixin.initActiveBtnStr 按 urlPath 匹配 winBtnStrList）
      urlPath: '/plugin/member/level',
      queryParam: {},
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '等级名称', dataIndex: 'name', width: 140 },
        { title: '排序', dataIndex: 'sort', width: 70, align: 'center' },
        { title: '升级门槛(累计实付)', dataIndex: 'upgradeAmount', width: 150, align: 'right' },
        { title: '保级金额(12个月)', dataIndex: 'keepAmount', width: 140, align: 'right' },
        {
          title: '折扣率',
          dataIndex: 'discountRate',
          width: 100,
          align: 'center',
          customRender: function(text) {
            return text ? text + '折' : '-'
          }
        },
        {
          title: '积分倍率',
          dataIndex: 'pointMultiple',
          width: 90,
          align: 'center',
          customRender: function(text) {
            return text || '-'
          }
        },
        { title: '默认', dataIndex: 'isDefault', width: 80, align: 'center', scopedSlots: { customRender: 'isDefaultSlot' } },
        { title: '状态', dataIndex: 'enabled', width: 80, align: 'center', scopedSlots: { customRender: 'enabledSlot' } },
        { title: '操作', dataIndex: 'action', width: 180, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/member/levels'
      }
    }
  },
  methods: {
    handleAdd() {
      this.$refs.modalForm.add()
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
    },
    handleToggle(record) {
      levelToggle(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleDelete(id) {
      levelDelete(id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
.table-operator { margin-bottom: 15px; }
</style>
